<template>
  <div>
    <div  style="display: flex; justify-content: space-between; width: 100%;">
      <div class="heading-text">{{ hraText }}</div>
      <div class="button-container">
        <div class="reset-button" @click="resetAllValue">
          <button>Reset</button>
        </div>
        <div class="copyToAll" @click="copyToAllValue">
          <button>Copy to all</button>
        </div>
      </div>
      <!-- <div class=" align-center" style="display: flex; align-items: center; gap: 5px;">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="addMoreDate()">Add New Date</button>
    </div> -->
    </div>
    <div v-if="!loading">
    <div class="row form-group my-3 hraMain" v-for="(item,index) in hraFormData.HRA.planned.details" :key="index">
      <div class="col-4 pl-0" style="cursor:not-allowed;">
        <div class="label">
          <span class="input-label">From Date</span>
          <date-picker
            name="fromDate"
            data-vv-as="from date"
            @datevalue="(val) => (item.from = val)"
            :value="item.from"
            v-validate="{ required: true }"
            :classname="errors.has('fromDate')"
            :errormsg="errors.first('fromDate')"
            disabled="true"
          />
        </div>
      </div>
      <div class="col-4" style="cursor:not-allowed;">
        <div class="label">
          <span class="input-label">To Date</span>
          <date-picker
            name="toDate"
            data-vv-as="to date"
            @datevalue="(val) => (item.to = val)"
            :value="item.to"
            v-validate="{ required: true }"
            :classname="errors.has('toDate')"
            :errormsg="errors.first('toDate')"
            :dates-disabled="{to: new Date(item.from)}"
            disabled="true"
          />
        </div>
      </div>
      <div class="col-4">
        <txt
          label="Amount"
          type="number"
          v-model="item.value"
          name="Amount"
          v-validate="'required'"
          :classname="errors.has('Amount')"
          :errormsg="errors.first('Amount')"
          @change="(val)=>{readValueMore(val, item, 'value')}"
        />
      </div>
      <div class="col-4 pl-0 pr-0 metroBtn">
        <txt
          label="Owner PAN Number"
          type="text"
          v-model="item.ownerDetails.panNumber"
          :name="`${index}owner PAN Number`"
          v-validate="{required: item.value > 8333 ? true : false, regex:pancardRegex}"
          :classname="errors.has(`${index}owner PAN Number`)"
          errormsg="Owner PAN number is required & should be in valid format"
          @change="(val)=>{readValueMore(val, item, 'pan')}"
        />
      </div>
      <div class="col-7  metroBtn">
          <tl-select
            label="City *"
            :options="metro_city_options"
            @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
            v-model="item.ownerDetails.metro"
          ></tl-select>

        <!-- <p class="text-metro">Metro</p>
        <div class="radio-grp">
          <tl-radio
            class="radio-grp-btn"
            :name="'mumbai'+index"
            label="Mumbai"
            :id="'mumbai'+index"
            value="mumbai"
            v-model="item.ownerDetails.metro"
            @change="(val)=>{setMetro(val, item), item.ownerDetails.metro = val}"
          />
          <tl-radio
            class="radio-grp-btn"
            :name="'chennai'+index"
            label="Chennai"
            :id="'chennai'+index"
            value="chennai"
            v-model="item.ownerDetails.metro"
            @change="(val)=>{setMetro(val, item), item.ownerDetails.metro = val}"
          />
          <tl-radio
            class="radio-grp-btn"
            :name="'kolkata'+index"
            label="Kolkata"
            :id="'kolkata'+index"
            value="kolkata"
            v-model="item.ownerDetails.metro"
            @change="(val)=>{setMetro(val, item), item.ownerDetails.metro = val}"
          />
          <tl-radio
            class="radio-grp-btn"
            :name="'delhi'+index"
            label="Delhi"
            :id="'delhi'+index"
            value="delhi"
            v-model="item.ownerDetails.metro"
            @change="(val)=>{setMetro(val, item), item.ownerDetails.metro = val}"
          />
          <tl-radio
            class="radio-grp-btn"
            :name="'other'+index"
            label="Other"
            :id="'other'+index"
            value="non_metro"
            v-model="item.ownerDetails.metro"
            @change="(val)=>{setMetro(val, item), item.ownerDetails.metro = val}"
          />
        </div> -->
        <!-- <tl-select
          label="Metro"
          :options="['Yes', 'No']"
          v-model="hraFormData.isMetro"
          @change="(val) => (hraFormData.isMetro = val)"
        ></tl-select> -->
      </div>
      <!-- <div class="col-1 metroBtn" v-if="hraFormData.HRA.planned.details.length > 1">
          <a class="delete-btn" @click="deleteHouse(index)">
          <img src="@/assets/delete.svg" />
          <span></span>
          </a>
      </div> -->
    </div>
    </div>
    <div v-if="loading" class="loadingDiv">
      <div class="loading"></div>
    </div>
    <!-- <div class="row form-group my-3">
      <div class="col-4 pl-0">
        <txt
          label="City"
          type="text"
          v-model="hraFormData.city"
          name="City"
          v-validate="'required'"
          :classname="errors.has('City')"
          :errormsg="errors.first('City')"
        />
      </div>
      <div class="col-4">
        <txt
          label="State"
          type="text"
          v-model="hraFormData.state"
          name="State"
          v-validate="'required'"
          :classname="errors.has('State')"
          :errormsg="errors.first('State')"
        />
      </div>
      <div class="col-4">
        <tl-select
          label="Metro"
          :options="['Yes', 'No']"
          v-model="hraFormData.isMetro"
          @change="(val) => (hraFormData.isMetro = val)"
        ></tl-select>
      </div>
    </div> -->
    <!-- <div class="row form-group my-3">
      <div class="col-4 pl-0">
        <txt
          label="Exemption Amount"
          type="text"
          v-model="hraFormData.exemption_amount"
          name="Exemption Amount"
          v-validate="'required'"
          :classname="errors.has('Exemption Amount')"
          :errormsg="errors.first('Exemption Amount')"
        />
      </div>
    </div> -->
    <br />
    <!-- <div class="heading-text">{{ calculateText }}</div> -->
    <!-- Table -->
    <!-- <div class="datatable-outer-container my-3">
      <div class="datatable-main">
        <table class="datatable">
          <thead>
            <tr class="header-row">
              <th>Details</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tr class="record-row">
            <td class="row-item">
              <strong>Actual HRA Received</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.actualHraReceived }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>Rent Paid minus 10% of Salary (Basic + DA)</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.rentPaidBasicDa }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>40% or 50% of Salary (Basic+DA)</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.percentSalBasicDa }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>Least of the above is exempted</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.leastExempted }}
            </td>
          </tr>
        </table>
      </div>
    </div> -->
    <!-- End -->
    <footer>
      <popup-bottom-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" @click="save"  v-if="itEnableValue" />
          </btn-grp>
        </template>
      </popup-bottom-container>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import * as globalConfig from "@/apis/config.js";

export default {
  props: {
    HraFormData: {
      type: Object
    },
    itEnableValue:{
      type: String,
      required: true
    },
    saveAsDraft: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: true,
      componentKey: 0,
      hraText: "Rent Paid Details for HRA Exemption",
      joiningFinancialYear: '',
      payrollFinancialYear: '',
      calculateText: "Calculate Exemption",
      pancardRegex: null,
      copyValue: 0,
      copyPanCard: "",
      copyMetro: "non_metro",
      metroTrueorFalse:"false",
      isCopyValue: false,
      isCopyMetro: false,
      isCopyPanCard: false,
      it_financial_year: null,
      date_of_joining: "",
      currentMonthIndex: null,
      fromMonths:[],
      toMonths:[],
      metro_city_options: ["Delhi", "Mumbai", "Kolkata", "Chennai", "Bengaluru", "Hyderabad", "Ahmedabad", "Pune", "Other"],
      previosHraFormData: {
        HRA: {

        }
      },
      hraFormData: {
        HRA: {
          actual: {
            status: false,
            details: []
          },
          planned: {
            status: true,
            details: []
          },
          approved: {
            status: false,
            details: []
          },
        }
      },
      setHraFormData: {
        HRA: {
          actual: {
            status: false,
            details: []
          },
          planned: {
            status: true,
            details: [
            {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
              {
                to: "",
                from: "",
                metro: false,
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "non_metro",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              },
            ]
          },
          approved: {
            status: false,
            details: [ ]
          }
        },
        others: []
      },
    };
  },
  mounted() {
    this.previosHraFormData = JSON.parse(JSON.stringify(this.HraFormData))
    this.getEmployeeData();
    this.pancardRegex = globalConfig.Regex.EMPLOYEE_PAN;
  },
  activated() {
    this.previosHraFormData = JSON.parse(JSON.stringify(this.HraFormData))
    this.getEmployeeData();
    this.pancardRegex = globalConfig.Regex.EMPLOYEE_PAN;
  },
  computed: {
    ...mapState({
      globalData: (state) => state.globalapi.globalData.data,
    }),
    empId(){
      return localStorage.getItem("empId")
    },
  },
  methods: {

    ...mapActions({
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll', 
    }),

    load() {
      let data = this.previosHraFormData;
      this.hraFormData.others = this.previosHraFormData.others;
        //  if(data.HRA.planned.details[0].ownerDetails.metro == ""){
        //   data.HRA.planned.details[0].ownerDetails.metro = 'non_metro';
        //   data.HRA.planned.details[0].metro = false
        //  }
        // this.hraFormData.HRA.planned.details[0].value = 9000;
        // console.log(this.hraFormData.HRA.planned.details[0].value);
        let firstIndexYear = this.payrollFinancialYear.split('-')[0];
        let secondIndexYear = this.payrollFinancialYear.split('-')[1]
        this.fromMonths.push(new Date(firstIndexYear, '03'),new Date(firstIndexYear, '04'),new Date(firstIndexYear, '05'),
        new Date(firstIndexYear, '06'),new Date(firstIndexYear, '07'),new Date(firstIndexYear, '08'),new Date(firstIndexYear, '09'),
        new Date(firstIndexYear, '10'),new Date(firstIndexYear, '11'),new Date(secondIndexYear, '0'),new Date(secondIndexYear, '01'),new Date(secondIndexYear, '02'))
        
        this.toMonths.push(new Date(firstIndexYear, '04', 0),new Date(firstIndexYear, '05', 0),new Date(firstIndexYear, '06', 0),
        new Date(firstIndexYear, '07', 0),new Date(firstIndexYear, '08', 0),new Date(firstIndexYear, '09', 0),new Date(firstIndexYear, '10', 0),
        new Date(firstIndexYear, '11', 0),new Date(firstIndexYear, '12', 0),new Date(secondIndexYear, '01', 0),new Date(secondIndexYear, '02', 0),new Date(secondIndexYear, '03', 0))
        let joining = (this.date_of_joining).split("-")[0];
        let month = (this.date_of_joining).split("-")[1];
        let financialYear = this.it_financial_year;
        if(this.joiningFinancialYear == this.payrollFinancialYear){
          let monthIndex = this.objectMap((this.date_of_joining).split("-")[1])
          this.setHraFormData.HRA.planned.details.splice(0, monthIndex);
          this.fromMonths.splice(0, monthIndex);
          this.toMonths.splice(0, monthIndex);
          this.setHraFormData.HRA.planned.details.map((element, index) => {
            element.from = this.fromMonths[index];
            element.to = this.toMonths[index];
          })
        }else{
          this.setHraFormData.HRA.planned.details.map((element, index) => {
            element.from = this.fromMonths[index];
            element.to = this.toMonths[index];
          })
        }

        if (data && Object.keys(data.HRA).length > 0 && data.HRA.planned.details.length > 0) {
          this.hraFormData.HRA = data.HRA;
        } else {
          this.hraFormData.HRA = this.setHraFormData.HRA
        }
        

          //console.log("inside the section 10",data);
      },

    goBack() {
      this.$emit("back");
    },

    setMetro(value, element){
      if(value == 'non_metro'){
        element.metro = false;
      }else{
        element.metro = true;
      }
      this.metroTrueorFalse = element.metro
      this.copyMetro = value;
      this.isCopyMetro = true;
    },

    objectMap(value){
      let  monthMap = new Map([
          ['04', 0],
          ['05', 1],
          ['06', 2],
          ['07', 3],
          ['08', 4],
          ['09', 5],
          ['10', 6],
          ['11', 7],
          ['12', 8],
          ['01', 9],
          ['02', 10],
          ['03', 11]
        ])

        let monthIndex = monthMap.get(value);
        if(monthIndex){
          return monthIndex;
        }
    },

    readValueMore(value, item, type){
      // console.log(value, item, type);
      if(type == "value"){
        this.copyValue = value;
        this.isCopyValue = true;
      }else{
        this.copyPanCard = value;
        this.isCopyPanCard = true;
      }
      // if(item.value > 0){
      //   this.hraFormData.HRA.planned.details.map(element => {
      //     if(element.value == 0){
      //       element.value = item.value;
      //     }
      //   })
      // }

    },

    copyToAllValue(){
      this.hraFormData.HRA.planned.details.map(element => {
          if(this.isCopyValue) element.value = this.copyValue;
          if(this.isCopyPanCard) element.ownerDetails.panNumber = this.copyPanCard;
          if(this.isCopyMetro) element.metro = this.metroTrueorFalse;
          if(this.isCopyMetro) element.ownerDetails.metro = this.copyMetro;
       })
    },

    async resetAllValue(){
      this.previosHraFormData.HRA.planned.details = []
      this.load();
      // this.componentKey += 1;
    },

    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("back");
          this.$emit("hraExemption", this.hraFormData);
        } else {
          // to navigate to error fields(PL- 1872) - 28/11/2019
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
          this.toast = true;
          this.errmsg = "Please fill mandatory fields!";
        }
      })
    },

    addMoreDate() {
      try {
        this.hraFormData.HRA.planned.details.push({
          to: "",
          from: "",
          metro: false,
          value: 0,
          ownerDetails: {
            name: "",
            state: "",
            toDate: "",
            address: "",
            pinCode: null,
            fileName: "",
            fromDate: "",
            metro: 'non_metro',
            panNumber: "",
            pancardUrl: ""
          },
          cownerDetails: {
            name: "",
            state: "",
            address: "",
            pincode: null,
            fileName: "",
            panNumber: "",
            pancardUrl: ""
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    deleteHouse(index) {
      try {
        this.hraFormData.HRA.planned.details.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    calculateJoiningFinancialYear(data){
      const date = new Date(data)
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // January is 0, so add 1

      // Financial year starts from April 1st, so check if the month is before April
      if (month < 4) {
        // If the month is before April, the financial year starts from the previous year
        return `${year - 1}-${year}`;
      } else {
        // If the month is April or later, the financial year starts from the current year
        return `${year}-${year + 1}`;
      }
    },

    calculatePayrollFinancialYear(year, month) {
      // Convert month to a number (January is 1, February is 2, etc.)
      month = month.toLowerCase();
      year = parseInt(year);
      // Financial year starts from April 1st
      if (month === 'jan' || month === 'feb' || month === 'mar') {
        // If the month is before April, the financial year starts from the previous year
        return `${year - 1}-${year}`;
      } else {
        // If the month is April or later, the financial year starts from the current year
        return `${year}-${year + 1}`;
      }
    },

    async getEmployeeData() {
      try {
        this.loading = true;
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        // console.log(response.data.payload[0]);
        // this.employee_name = response.data.payload[0].first_name;
        // this.employee_code = response.data.payload[0].code;
        this.it_financial_year = response.data.payload[0].payrollDetails.year;
        let month = response.data.payload[0].payrollDetails.month;
        this.date_of_joining = (response.data.payload[0].date_of_joining).slice(0, 10);
        this.joiningFinancialYear = this.calculateJoiningFinancialYear(this.date_of_joining);
        this.payrollFinancialYear = this.calculatePayrollFinancialYear(this.it_financial_year, month);
        this.load();
        this.loading = false;
        // console.log((this.date_of_joining).split("/")[2], this.it_financial_year);
        // if((this.date_of_joining).split("/")[0] == this.it_financial_year){
        //   //console.log(this.getCurrentMonthIndex((this.date_of_joining).split("/")[1]));
        //   let month = this.getCurrentMonthIndex((this.date_of_joining).split("/")[0])
        //   console.log(month);
        //   this.months.slice(0, 0)
        // }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        this.loading = false;
      }
    },

    
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.button-container{
  display: flex;
  gap: 20px;
  align-items: center;
}

.reset-button{
  background-color: #34c0bd;
  color: #ffffff;
  padding: 10px 25px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
}

.loadingDiv{
  display: flex;
  justify-content: center;
  height: 70vh;
  align-items: center;
}

.loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #376cd3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.heading-text {
  font-weight: bold;
  font-size: 1.1rem;
}

.delete-btn{
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-top: 30px;
}

.copyToAll{
  background-color: #34c0bd;
  color: #ffffff;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
}

.metroBtn{
  margin-top: 10px;
}

.hraMain{
  margin-bottom:50px !important;
}

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}

.datatable-outer-container table.datatable {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  font-family: Montserrat;
  margin-bottom: 4px;
}

.datatable-outer-container table.datatable .header-row {
  background-color: white;
  height: 54px;
}

.datatable-outer-container table.datatable .header-row th {
  background-color: #f0f1f5;
  border-bottom: 1px solid #34c0be;
  padding: 6px 20px;
}

.datatable-outer-container table.datatable .header-row th .tl-checkbox {
  text-align: center;
}

.datatable-outer-container table.datatable .inactiveCols {
  opacity: 0.03;
  background-color: #a2a1a1;
}

.datatable-outer-container table.datatable .Editdeleteheader {
  background-color: #ffffff;
  -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
  box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
}

.datatable-outer-container table.datatable .Editdeleteheader th {
  padding: 0 8px;
}

.datatable-outer-container table.datatable .Editdeleteheader th span {
  border-right: 1px solid #ececec;
  padding: 0px 18px 0px 15px;
  display: inline-block;
  vertical-align: middle;
}

.datatable-outer-container
  table.datatable
  .Editdeleteheader
  th
  span:first-child {
  padding: 10px 10px 7px 10px;
}

.datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
  text-align: right;
}

.datatable-outer-container
  table.datatable
  .Editdeleteheader
  th:last-of-type
  span {
  border-right: none;
  font-weight: 400;
  font-style: italic;
  position: relative;
}

.datatable-outer-container
  table.datatable
  .Editdeleteheader
  th:last-of-type
  span
  i {
  position: absolute;
  right: 10px;
  top: 2px;
}

.datatable-outer-container table.datatable .record-row {
  height: 54px;
  border-bottom: none;
}

.datatable-outer-container table.datatable .record-row:nth-child(odd) {
  background-color: #fff;
}

.datatable-outer-container table.datatable .record-row.selectedRecord {
  background-color: #e9f9f8;
  opacity: 0.9;
}

.datatable-outer-container table.datatable .record-row td {
  padding: 6px 8px;
  color: #646464;
  font-weight: 500;
}

.datatable-outer-container table.datatable .record-row td .tl-checkbox {
  text-align: center;
}

.datatable-outer-container table.datatable .record-row .actions {
  width: 10%;
  padding: 10px;
}

.datatable-outer-container table.datatable .record-row .row-item {
  padding: 6px 20px;
}

.datatable-outer-container table.datatable .record-row .row-item p {
  width: 100%;
  margin-bottom: 0px;
}

.datatable-outer-container table.datatable .record-row .action-img {
  display: inline-block;
  cursor: pointer;
  opacity: 0;
}

.datatable-outer-container table.datatable .record-row:hover .action-img {
  opacity: 1;
}

.inputbox {
  width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

.text-metro {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
  margin-right: 32px;
  color: #444444;
}

.radio-grp {
  display: flex;
  flex-wrap: wrap;
}

.radio-grp-btn {
  //float: left;
  width: 20%;
  padding-bottom: 5px;
}
</style>

